import axios from 'axios';
import { IRelease } from '../../entities/release';

export async function getReleases(): Promise<IRelease[]> {
  const { data: releases } = await axios.get<IRelease[]>('/releases/latest');
  return releases;
}
